module.exports = __webpack_public_path__ + "static/media/maki_cocumber.c9030552.webp";